import { axiosInstance } from '@/api/axiosInstance';
import { AxiosRequestConfig } from 'axios';
import { PlayGameRequest } from 'swagger/models';
import { PlayerGameApi } from '../../swagger/api';
import { Configuration } from '../../swagger/configuration';
import { getFirebaseIDToken } from "./auth/firebase";

const getAccessToken = async () => {
  const accessToken = await getFirebaseIDToken()
  return accessToken;
};

const getApiConfig = () => new Configuration({
  basePath: process.env.NEXT_PUBLIC_API_URL,
  //@ts-ignore
  accessToken: getAccessToken,
});

const apiConfiguration = getApiConfig();

const PLAYER_API = new PlayerGameApi(apiConfiguration, apiConfiguration.basePath, axiosInstance);

export const finishGamePlayer = async (body: PlayGameRequest, gameId: string, options?: AxiosRequestConfig) => PLAYER_API.playGame(body, gameId, options);

